<!--<div class="ui-g-12" style="display: flex; align-items: center;">
  <div class="ui-g-2" style="margin: 0 auto;">
    <img src="../../assets/images/telemedicina/paso1.png" style="width: 25%;">
  </div>
</div>
<div class="p-fluid">
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12">
      <label >Card Holder Name</label>
      <input type="text" required pInputText [(ngModel)]="paymentInformation.cardholderName">
    </div>
    <div class="p-field p-col-8">
      <label id="number" >Number</label>
      <p-inputMask inputId="number" mask="9999-9999-9999-9999" [(ngModel)]="paymentInformation.cardholderNumber"></p-inputMask>
    </div>
    <div class="p-field p-col-2">
      <label id="date" for="date">Date</label>
      <p-inputMask inputId="date" mask="99/99" [(ngModel)]="paymentInformation.date"></p-inputMask>
    </div>
    <div class="p-field p-col-2">
      <label for="cvv">CVV</label>
      <p-inputMask id="cvv" mask="999" [(ngModel)]="paymentInformation.cvv"></p-inputMask>
    </div>
    <div class="p-field-checkbox p-col-12">
      <p-checkbox id="remember" [binary]="true" [(ngModel)]="paymentInformation.remember"></p-checkbox>
      <label for="remember" class="p-checkbox-label">Save credit card information for future</label>
    </div>
  </div>
</div>
<div class="p-grid p-nogutter p-justify-between">
  <p-button label="Back" (onClick)="prevPage()" icon="pi pi-angle-left"></p-button>
  <p-button label="Next" (onClick)="nextPage()" icon="pi pi-angle-right" iconPos="right"></p-button>
</div>-->
<div class="ui-g-12">
  <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 10%;" label="Regresar" (click)="prevPage()" icon="pi pi-angle-left"></button>
</div>
<div class="ui-g-12" style="margin-top: 10%;">
  <ng-payment-card
    style="padding-top: 10px;"
    button="ui-button-secondary"
    ccNumMissingTxt="Please provide card number"
    cardExpiredTxt="Payment card has expired"
    [validateCardExpiration]="true"
    [validateCCNum]="true"
    [validateCCV]="true"
    (formSaved)="processPayment($event)">
  </ng-payment-card>
 
</div>

